module.exports = __webpack_public_path__ + "static/media/cart-icon.e0a2dec7.png";